import React, { useEffect } from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a1628] py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#132238] rounded-xl p-6 sm:p-10 border border-[#1a2d47]">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-8 h-8 text-[#ff6b35]" />
            <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
          </div>
          
          <div className="prose prose-invert max-w-none text-[#a8b8d0]">
            <p className="mb-6">
              This privacy notice discloses the privacy practices for this web site. This privacy notice applies solely to information collected by this web site. It will notify you of the following:
            </p>
            
            <ol className="list-decimal list-inside mb-6 space-y-2">
              <li>What personally identifiable information is collected from you through the web site, how it is used and with whom it may be shared.</li>
              <li>What choices are available to you regarding the use of your data.</li>
              <li>The security procedures in place to protect the misuse of your information.</li>
              <li>How you can correct any inaccuracies in the information.</li>
            </ol>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">Information Collection, Use, and Sharing</h2>
            <p className="mb-4">
              We are the sole owners of the information collected on this site. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell or rent this information to anyone.
            </p>
            <p className="mb-4">
              We will use your information to respond to you, regarding the reason you contacted us. We will not share your information with any third party outside of our organization, other than as necessary to fulfill your request, e.g. to ship an order.
            </p>
            <p className="mb-6">
              Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or services, or changes to this privacy policy.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">Your Access to and Control Over Information</h2>
            <p className="mb-4">
              You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us via the email address or phone number given on our website:
            </p>
            <ul className="list-disc list-inside mb-6 space-y-2">
              <li>See what data we have about you, if any.</li>
              <li>Change/correct any data we have about you.</li>
              <li>Have us delete any data we have about you.</li>
              <li>Express any concern you have about our use of your data.</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">Security</h2>
            <p className="mb-4">
              We take precautions to protect your information. When you submit sensitive information via the website, your information is protected both online and offline.
            </p>
            <p className="mb-4">
              Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your web browser, or looking for "https" at the beginning of the address of the web page.
            </p>
            <p className="mb-6">
              While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.
            </p>
            <p className="mb-6">
              If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone or via email.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">Cookies</h2>
            <p className="mb-4">
              We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us improve your access to our site and identify repeat visitors to our site. For instance, when we use a cookie to identify you, you would not have to log in a password more than once, thereby saving time while on our site. Cookies can also enable us to track and target the interests of our users to enhance the experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on our site.
            </p>
            <p className="mb-6">
              Some of our business partners may use cookies on our site (for example, advertisers). However, we have no access to or control over these cookies.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">Links</h2>
            <p className="mb-4">
              This web site contains links to other sites. Please be aware that we are not responsible for the content or privacy practices of such other sites. We encourage our users to be aware when they leave our site and to read the privacy statements of any other site that collects personally identifiable information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
